import { Content } from "@jobber/components/Content";
import { Tabs, Tab } from "@jobber/components/Tabs";
import { DashboardFrame } from "../../components/Dashboard";
import Franchises from "../Dashboard/Franchises";
import Locations from "../Dashboard/Locations";
import SyncJobs from "../Dashboard/SyncJobs";
import UserMapping from "../Dashboard/UserMapping";

function Dashboard() {
    return (
        <DashboardFrame>
            <Content type={"div"} spacing={"base"}>
                <Tabs>
                    <Tab label={"Connected Franchises"}>
                        <Franchises />
                    </Tab>
                    <Tab label="Location Mapping">
                        <Locations />
                    </Tab>
                    <Tab label="User Mapping">
                        <UserMapping />
                    </Tab>
                    <Tab label="Sync Jobs">
                        <SyncJobs />
                    </Tab>
                </Tabs>
            </Content>
        </DashboardFrame>
    );
}

export default Dashboard;
